function getUserFullName (user) {
  const fullName = user?.profile?.full_name || user?.name
  if (!fullName) return ''
  return fullName.trim()
}

export {
  getUserFullName
}
